import { inject } from '@angular/core';
import { ApiService } from './api.service';

export abstract class CrudApiServiceService<T, K = number> {
    private readonly apiService = inject(ApiService);

    abstract getEndpoint(): string;

    getAll() {
        return this.apiService.get<T[]>(this.getEndpoint());
    }

    get(id: K) {
        return this.apiService.get<T>(`${this.getEndpoint()}/${id}`);
    }

    create(data: T) {
        return this.apiService.post<T>(this.getEndpoint(), data);
    }

    update(id: K, data: T) {
        return this.apiService.patch<T>(`${this.getEndpoint()}/${id}`, data);
    }

    delete(id: K) {
        return this.apiService.delete<null>(`${this.getEndpoint()}/${id}`);
    }
}
